<template>
  <div class="sidebar">
    <!-- {{ listed[0] }}s -->

    <SidebarList v-if="loading" v-for="items in 10" />
    <div v-else>
      <div class="sidebar-static-header">
        <p class="sidebar-heading">{{ masterheading }}</p>
        <p class="light-txt count-shows">
          Showing {{ listed.length }} {{ listtype }}
        </p>
      </div>
      <div class="scrollable-left-sidebar">
        <div class="sidebar-det-list" v-for="items in listed">

          <ul @click="passId(items)">
            <li>
              <div class="d-flex justify-content-between me-2">
                <p class="light-txt id-style">{{ items!["Code"] }}</p>
              </div>
              <div class="d-flex align-items-center justify-content-between my-1 me-2">
                <div class="d-flex align-items-center">
                  <span v-if="items!['StoreTypeId'] == '1'" class="main-store">MS</span>
                  <span v-if="items!['StoreTypeId'] == '2'" class="Sub-store">SS</span>
                  <span v-if="items!['StoreTypeId'] == '3'" class="dep-store">DS</span>
                  <h6 class="sidebar-det-list-name" :title="String(items!['Name'])">
                    {{ inorout == "in" ? items!["FromStoreName"] : items!["Name"] }}
                  </h6>
                </div>
                <GreenStatus v-if="items!['ItemQty']" :name="items!['ItemQty']" />
              </div>
              <div class="d-flex justify-content-between mt-1 me-2" v-if="masterheading != 'Returns'">

                <h6 class="sidebar-det-list-name">
                  <p class="name-style" :title="String(items!['ReceivedByName'])" v-if="items!['ReceivedByName']"> {{
                    items!["ReceivedByName"] }}</p>
                  <p class="name-style" :title="String(items!['IssuedByName'])" v-if="items!['IssuedByName']"> {{
                    items!["IssuedByName"] }}</p>
                </h6>
                <h6 class="sidebar-det-list-name">
                  <p class="light-txt id-style" :title="String(items!['ReceivedDate'])" v-if="items!['ReceivedDate']">
                    {{ items!["ReceivedDate"] }}</p>
                  <p class="light-txt id-style" :title="String(items!['IssuedDate'])" v-if="items!['IssuedDate']"> {{
                    items!["IssuedDate"] }}</p>
                </h6>
              </div>
              <div class="d-flex justify-content-between mt-1 me-2" v-else>
                <h6 class="sidebar-det-list-name">
                  <p class="name-style" :title="String(items!['ReturnedByName'])" v-if="items!['ReturnedByName']"> {{
                    items!["ReturnedByName"] }}</p>
                </h6>
                <h6 class="sidebar-det-list-name">
                  <p class="light-txt id-style" :title="String(items!['ReturnDate'])" v-if="items!['ReturnDate']"> {{
                    items!["ReturnDate"] }}</p>
                </h6>
              </div>

              <!-- <div v-else class="d-flex justify-content-between mt-1 me-2">
                <h6 class="sidebar-det-list-name">
                  <p class="name-style" v-if="items!['IssuedByName']"> {{ items!["IssuedByName"] }}</p>
                </h6>
                <h6 class="sidebar-det-list-name">
                  <p class="light-txt id-style" v-if="items!['IssuedDate']"> {{ items!["IssuedDate"] }}</p>
                </h6>
              </div> -->
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType, ref } from "vue";
import { RouterLink, RouterView, useRouter, useRoute } from "vue-router";
import SidebarList from "../../../../components/SkeletonLoaderComponents/SidebarList.vue";
export default defineComponent({
  props: {
    title: {
      type: String,
      default: "",
    },
    listed: {
      type: Array as PropType<Record<string, unknown>[]>,
      default: [],
    },
    storestatus: {
      type: Boolean,
      default: false,
    },
    masterheading: {
      type: String,
      default: "",
    },
    pagename: {
      type: String,
      default: "",
    },
    loading: {
      type: Boolean,
      default: false,
    },
    listtype: {
      type: String,
      default: "",
    },
    inorout: {
      type: String,
      default: "",
    },
  },
  components: {
    SidebarList,
  },
  setup(props, { emit }) {
    // const model = ref({
    //     Id: ""
    // });
    const router = useRouter();
    const route = useRoute();

    function passId(data) {

      emit("clickdata");
      emit("update:modelValue", data);

      // emit("update:modelValue", data!['Id']);
      debugger;
      if (props.pagename == "ItemMasterDetails") {
        router.push({
          name: props.pagename,
          query: {
            id: data!["Id"],
            itemcategoryId: data!["ItemCategoryId"],
          },
        });
      } else if (props.pagename == "StoreMasterDetails") {
        // alert('s')
        // router.push({
        //     name: props.pagename,
        //     query: {
        //         storeId: data!['Id'],
        //         storeType: data!['StoreTypeId']
        //     }
        // });
        router.push({
          name: props.pagename,
          path: "/StoreMasterDetails",
          query: {
            Id: data!["Id"],
            Type: "StoreId",
            storeType: data!["StoreTypeId"],
            storebranchmapid: data!["StoreBranchMapId"],
          },
        });
      } else if (props.pagename == "SupplierMasterDetailsView") {
        router.push({
          path: "/SupplierMasterDetailsView",
          query: {
            Id: data!["Id"],
            Type: "SupplierId",

          },
        });
      } else if (props.pagename == "InboundIssueDetails") {
        router.push({
          path: "/InboundIssueDetails",
          query: {
            Id: data!["StockTransId"],
            BranchId: data!["ToStoreBranchId"]
            //storeid: data!["ToStoreId"],
          },
        });
      } else if (props.pagename == "IssueDetails") {
        console.log("Issuedetails", data);
        router.push({
          path: "/IssueDetails",
          query: {
            id: data!["Id"],
            storeid: data!["FromStoreId"],
          },
        });
      } else if (props.pagename == "IssueReturnDetails") {

        router.push({
          path: "/IssueReturnDetails",
          query: {
            // id: data!["StockTransId"],
            // storeid: data!["FromStoreId"],
            id: route.query.type == "Outbound" ? data!["Id"] : data!["StockTransId"],
            storeid: route.query.type == "Outbound" ? data!["FromStoreId"] : data!["ToStoreId"],
            refid: data!["RefId"],
            type: route.query.type,
            BranchId: data.BranchId
          },
        });

      } else if (props.pagename == "SupplierPaymentDetails") {
        router.push({
          path: "/SupplierPaymentDetails",
          query: {
            Id: data!["SupplierId"],
            StoreId: route.query.StoreId,
            StoreBranchMapId: route.query.StoreBranchMapId
          },
        });
      }
      else if (props.pagename == "SalseOrderDetails") {
        console.log("SalseOrderDetails", data);
        router.push({
          path: "/SalseOrderDetails",
          query: {
            id: data!["Id"],
            storeid: data!["FromStoreId"],
          },
        });
      }

      else {
        router.push({
          name: props.pagename,
          query: {
            id: data!["Id"],
            // itemcategoryId: data!['ItemCategoryId']
          },
        });
      }
    }
    return {
      passId,
    };
  },
});
</script>

<style lang="scss" scoped>
.sidebar {
  width: 100%;
  box-shadow: rgb(0 0 0 / 16%) 0px 1px 4px;
  background-color: white;
  // height: 100% !important;
  // overflow: scroll;
  // min-height: 100vh;

  .count-shows {
    font-weight: 300;
    font-size: 12px;
    // padding-top: 10px;
  }

  .sidebar-static-header {
    background-color: white;
    padding: 15px;
    font-weight: 600;
    border-bottom: 5px solid #f8f9fe;
    // position: sticky;
    // top: 0px;
    // left: 0px;

    .sidebar-heading {
      font-size: 16px;
    }
  }

  .sidebar-det-list {
    .main-store {
      font-size: 10px;
      border-radius: 50%;
      background-color: #cdd0fb;
      padding: 10px;
      // width: 120px;
      // height: 120px;
      margin-right: 10px;
    }

    .Sub-store {
      font-size: 10px;
      border-radius: 50%;
      background-color: #fff3cc;
      padding: 10px;
      // width: 120px;
      // height: 120px;
      margin-right: 10px;
    }

    .dep-store {
      font-size: 10px;
      border-radius: 50%;
      background-color: #ffcccc;
      padding: 10px;
      // width: 120px;
      // height: 120px;
      margin-right: 10px;
    }

    &:focus {
      background-color: #f8f9fe;
    }

    &:hover {
      background-color: #f8f9fe;
    }

    ul {
      //background-color: #ffcccc;
      border-bottom: #f2f2f2 2px solid;
      padding-left: 15px;
      padding-top: 10px;
      padding-bottom: 10px;
    }

    .id-style {
      font-size: 12px;
      font-weight: 500;
    }
  }

  .sidebar-det-list-name {
    font-weight: 600;
    font-size: 14px !important;
    width: 180px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap
  }

  .scrollable-left-sidebar {
    height: 75vh;
    overflow: auto;
  }
}

.sidebar-det-list {
  cursor: pointer;
}

.name-style {
  font-size: 13px;
  font-weight: 500;
}

@media screen and (min-width: 1400px) {
  .sidebar {
    .scrollable-left-sidebar {
      height: 78vh;
    }
  }
}
</style>
